import { connect } from "react-redux";

import Dashboard from "./Dashboard";

export default connect((state) => {
  return {
    profile: state.auth.profile,
  };
}, {})(Dashboard);
